import { get } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { and, not } from 'ember-truth-helpers';
import { ROOMTYPES } from 'frontend-utils/models/roomtype';
import { OTA_IDS } from 'frontend-utils/utils/constants/constant-values';
import GeneralRateIcons from 'lumen/components/general/rate-icons';
import HotelTooltipsTooltipRatesTable from 'lumen/components/hotel/tooltips/tooltip-rates-table';
import getNumberSignClass from 'lumen/helpers/get-number-sign-class';

const MEALPLAN_ID = 0; // Mealplan can't be changed in Overview, it's hardcoded to this

interface HotelOverviewDashboardTilesMarketTrendsPriceDifferenceDailyViewCellRateSignature {
  Args: {
    compsetId: unknown;
    hotel: unknown;
    hotelData: unknown;
    isAllChannelsSelected: unknown;
    otaId: unknown;
    rateParam: unknown;
  };
}

export default class HotelOverviewDashboardTilesMarketTrendsPriceDifferenceDailyViewCellRate extends Component<HotelOverviewDashboardTilesMarketTrendsPriceDifferenceDailyViewCellRateSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // In Overview, only some params can be changed (rateParam, otaId and compsetId), the rest is fixed.
  // The Rates table tooltip is only shown for All Channels (determined by isAllChannelsSelected prop),
  // so otaId can be set to OTA_IDS.ALL_CHANNELS for the request.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get losRequestParams() {
    return {
      compareType: '',
      compareValue: '',
      compsetId: this.args.compsetId,
      los: this.hotelAndMarketService.hotelOrMarket.defaultLosRates[0],
      maxPersons: this.hotelAndMarketService.hotelOrMarket.defaultPersons,
      mealPlan: MEALPLAN_ID,
      membershipType: 0,
      otaId: OTA_IDS.ALL_CHANNELS,
      platform: -1,
      rateParam: this.args.rateParam,
      roomType: ROOMTYPES.ALL,
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get ratesTooltipValues() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    const allowedOTAS = this.args.hotelData.otas.map((ota) => ota.id);
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ratesForHotel = this.args.hotelData.rates;

    // Filter all rates for specific channel on which the current hotel does not have matchings
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return ratesForHotel.filter((rate) => allowedOTAS.includes(rate.ota));
  }

  <template>
    {{! @glint-nocheck }}
    <div class="flex items-center" role="tooltip">
      {{@hotelData.formattedRate}}

      {{! Don't show the change when the selected OTA is All Channels. }}
      {{#if
        (and
          @hotelData.formattedRateChangeVersusReference
          (not @isAllChannelsSelected)
        )
      }}
        (<span
          class={{getNumberSignClass @hotelData.rateChangeVersusReference}}
        >
          {{@hotelData.formattedRateChangeVersusReference}}
        </span>)
      {{/if}}

      <GeneralRateIcons
        @mealPlan={{MEALPLAN_ID}}
        @otaId={{@otaId}}
        @rate={{get @hotelData.rates "0"}}
        @rateParam={{@rateParam}}
      />
      {{! Show the Rates table tooltip when the selected OTA is All Channels. }}
      {{#if @isAllChannelsSelected}}
        <HotelTooltipsTooltipRatesTable
          @hotel={{@hotel}}
          @isAllChannels={{true}}
          @requestParams={{this.losRequestParams}}
          @value={{this.ratesTooltipValues}}
        />
      {{/if}}
    </div>
  </template>
}
